{
  "R": [0, 0],
  "G": [0, 255],
  "B": [255, 255],
  "A": [0, 128],
  "I": [0, 255]
}
